'use client';
import type { SVGProps } from "react";
import type { FC } from 'react';
import type { IconProps } from '../utils/type';
import { SvgIconWrapper } from '../utils/svg-icon-wrapper';
/**
 * Auto-generated icon component: Do not change this component manually.
 * Config file: customSvgrTemplate.js
 */
const SvgBase: FC<IconProps> = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}><path fill="currentColor" fillRule="evenodd" d="m3.483 5.857-2.24 8.598A5 5 0 1 0 11 16v-2h2v2a5 5 0 1 0 9.825-1.314l-.014-.064-2.292-8.767A3.821 3.821 0 0 0 13 6.82V8h-2V6.82a3.82 3.82 0 0 0-7.517-.963M7.179 5a1.82 1.82 0 0 0-1.761 1.361l-1.304 5.007A5 5 0 0 1 6 11c1.125 0 2.164.372 3 1V6.82A1.82 1.82 0 0 0 7.18 5M3.062 15.408l-.011.039Q3 15.716 3 16a3 3 0 0 0 6 .024v-.072a3 3 0 0 0-5.84-.921zM13 12v-2h-2v2zm8 4a3 3 0 0 1-6 .022v-.066A3 3 0 0 1 21 16m-6-4c.836-.628 1.875-1 3-1 .67 0 1.31.132 1.894.371l-1.31-5.01A1.821 1.821 0 0 0 15 6.82z" clipRule="evenodd" /></svg>;
const IconBinoculars = ({
  $size,
  $color,
  className,
  ...rest
}: IconProps) => <SvgIconWrapper $size={$size} $color={$color} className={className}><SvgBase {...rest} /></SvgIconWrapper>;
export default IconBinoculars;